'use strict';

(function () {
  'use strict';

  angular.module('vnext').service('referralSvc', referralSvc);

  angular.module('referrals').service('referralSvc', referralSvc);

  referralSvc.$inject = ['$http'];

  /* @ngInject */
  function referralSvc($http) {
    return {
      postReferral: _postReferral,
      getReferralSettings: _getReferralSettings,
      getReferralOrgReferralSettings: _getReferralOrgReferralSettings
    };

    function _getReferralOrgReferralSettings(organization) {
      return $http.get('/apiproxy/public/referral/settings?organization=' + organization, {}).then(function (dat) {
        return dat.data;
      });
    }

    //get referral settings
    function _getReferralSettings(org, group, ac) {
      var url = '/apiproxy/public/referral/settings/' + org;
      if (ac || group) {
        url = url + '?' + (group ? 'group=' + group + '&' : '') + (ac ? 'accesscode=' + ac : '');
      }
      return $http.get(url).then(function (resp) {
        return resp.data;
      });
    }

    function _postReferral(referralFields, customFields) {
      //filter away the custom field responses that went unanswered,
      //since we won't be mapping them to anything at sign-up and don't need
      //to store empty response rows
      referralFields.referralCustomFieldResponses = customFields.filter(function (c) {
        return c && c.fieldResponse;
      }).map(function (field) {
        return {
          fieldName: field.fieldName,
          fieldResponse: field.fieldResponse,
          signUpFieldCollectionId: field.signUpFieldCollectionId,
          signUpFieldName: field.signUpFieldName
        };
      });
      return $http.post('/apiproxy/public/referral', referralFields);
    }
  }
})();